import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, FileText } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/mtxbdlm5_cell%209%202.jpg"
          alt="Infrastructure Construction"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/75 via-slate-900/70 to-slate-900/65"></div>
      </div>

      {/* Watermark Logo - Top Right */}
      <div className="absolute top-32 right-8 z-10 opacity-50">
        <img 
          src="https://customer-assets.emergentagent.com/job_c9938d68-1681-4c70-a0d0-2eb4390b972e/artifacts/7as7vd01_White%20logo%20-%20no%20background.svg"
          alt="RHE Watermark"
          className="h-32 w-auto"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Project Management Services
          </h1>
          
          <p className="text-xl md:text-2xl text-slate-200 mb-6 leading-relaxed">
            RHE Project Consulting provides specialist project management services supporting the delivery of infrastructure and capital works programs across NSW.
          </p>
          
          <p className="text-lg text-slate-300 mb-10 leading-relaxed">
            Our experienced team supports government agencies in delivering complex infrastructure projects including transport upgrades, waste infrastructure, environmental remediation, coastal protection works and disaster recovery programs.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              variant="outline"
              onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-blue-900 px-8 py-6 text-lg font-semibold transition-all duration-300"
            >
              Discuss Your Project
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <span className="text-white text-sm font-medium">Scroll to explore</span>
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </section>
  );
};
